import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';


export const ERROR_MSG = css`
  padding: 12px;
  background-color: ${COLORS.RED};
  color: ${COLORS.WHITE};
  border-radius: 8px;
  font-size: 12px;
`;
